import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_update_delivery_status } from "../../../networking/urlEndPoints";

import { removeTodayDispenePatientById } from "../../slices/dispense/patientForRouteList";
import { fetchPatientPendingList } from "./patientPendingList";

export const updateDeliveryStatus = createAsyncThunk('updateDeliveryStatus', async (requesteData, { rejectWithValue }) => {
	try {
		const datas = {
			pharmacy_id: requesteData.pharmacy_id,
		}

		const response = await Axios.post(`${driver_update_delivery_status}/${requesteData?.patient_id}`, datas);
		const data = response.data;

		if (response?.status === 200) {
			if (requesteData.params?.pharmacy_id && requesteData.params?.route) {
				requesteData.dispatch(removeTodayDispenePatientById(requesteData?.patient_id))
			}
		}

		if (typeof requesteData.setOpenIndex === 'function') {
			requesteData.setOpenIndex(null)
		}

		return data;

	} catch (error) {
		if (requesteData.type === 'Pending_dispense') {
			requesteData.dispatch(fetchPatientPendingList({
				page: 1,
				pharmacy_id: requesteData.pharmacy_id,
				// setLoading: setLoading
			}))
		}
		return rejectWithValue(error.response)
	}
});